export const constWidgetSize = {
    padding:10,
    title:48,
    footerPaddingBottom:6,
    fontHeight:8,
    border:2
}